import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';

export const RozmerPneuDisku = {
	name: NAME,
	apiProvider,
	router,
};
